export const onAuthorized = (profile) => ({
  type: 'AUTHORIZED',
  profile
})
